import PropTypes from 'prop-types';

const intlShape = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
  formatDate: PropTypes.func,
  formatTime: PropTypes.func,
  formatNumber: PropTypes.func,
  locale: PropTypes.string,
});

export default intlShape;
